import { createApp } from 'vue'
import App from './App.vue';
import router from './router';

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

const vueApp = createApp(App);
vueApp.use(router);
vueApp.mount('#app');

